import React = require("react");
import {ProductCategory} from "./EquipmentProductCategorySettings";

interface EquipmentProductCategorySettingsContentConfiguration {
    selectProductCategoryText: string;
    insertTemperatureLimitsText: string;
    minTemperatureText: string;
    maxTemperatureText: string;
    locale: string;
    notSetTypeOptionText: string;
    recommendedThresholds: string;
}

interface EquipmentProductCategorySettingsContentProps {
    configuration: EquipmentProductCategorySettingsContentConfiguration;
    minTemperature: number;
    maxTemperature: number;
    selectedProductCategory: ProductCategory;
    productCategories: ProductCategory[];
    onCategoryChange: (category: ProductCategory) => any;
    onMinTemperatureChange: (temperature: number) => any;
    onMaxTemperatureChange: (temperature: number) => any;
    // the error string received from the server in case of error response
    error: string;
    unitOfMeasure: string;
}

const OTHER_PRODUCT_CATEGORY_GUID = "51d6d642-caf5-11e8-9c0a-9418826ed820";

export const EquipmentProductCategorySettingsContent: React.SFC<EquipmentProductCategorySettingsContentProps> =
    (props) => {
        const getProductCategory = (guid: string) => {
            if (guid === "") {
                return null;
            }
            for (const productCategory of props.productCategories) {
                if (productCategory.guid === guid) {
                    return productCategory;
                }
            }
            return null;
        };

        const getRecommendedThresholdsText = (categoryName: string,
                                              min: number,
                                              max: number,
                                              unitOfMeasure: string): string => {
            let result: string = props.configuration.recommendedThresholds;
            result = result.replace("{0}", categoryName);
            result = result.replace("{1}", "" + min);
            result = result.replace("{2}", "" + max);
            result = result.replace("{3}", unitOfMeasure);
            result = result.replace("{4}", unitOfMeasure);
            return result;
        };

        const options: JSX.Element[] = props.productCategories
            .sort((row1, row2) => row1.name.localeCompare(row2.name))
            .map((product, index) => (
                    <option key={index} value={product.guid}>
                        {product.name}
                    </option>
                ),
            );
        let temperaturesContent = null;
        let recommendedThresholdsSpan = null;
        if (props.selectedProductCategory != null) {
            if (props.selectedProductCategory.guid !== OTHER_PRODUCT_CATEGORY_GUID) {
                recommendedThresholdsSpan = (
                    <p className={"settings-content__recommended-thresholds"}>
                        {
                            getRecommendedThresholdsText(
                                props.selectedProductCategory.name,
                                props.selectedProductCategory.minTemperature,
                                props.selectedProductCategory.maxTemperature,
                                props.unitOfMeasure,
                            )
                        }
                    </p>
                );
            }
            const onMinTemperatureChange = (evt) => {
                props.onMinTemperatureChange(parseFloat(evt.target.value));
            };
            const onMaxTemperatureChange = (evt) => {
                props.onMaxTemperatureChange(parseFloat(evt.target.value));
            };
            temperaturesContent = (
                <fieldset>
                    <p className="settings-content__title">{props.configuration.insertTemperatureLimitsText}</p>
                    <div className={"settings-content__data-row"}>
                        <span className={"settings-content__label"}>{props.configuration.minTemperatureText}:</span>
                        <input
                            type="number"
                            className={"settings-content__temperature-input"}
                            onChange={onMinTemperatureChange}
                            value={props.minTemperature}
                        />
                        <span> {props.unitOfMeasure}</span>
                        <span className={"settings-content__label"}>{props.configuration.maxTemperatureText}:</span>
                        <input
                            type="number"
                            className={"settings-content__temperature-input"}
                            onChange={onMaxTemperatureChange}
                            value={props.maxTemperature}
                        />
                        <span> {props.unitOfMeasure}</span>
                        {recommendedThresholdsSpan}
                    </div>
                </fieldset>
            );
        }
        let error = null;
        if (props.error != null) {
            error = (
                <div className={"settings-error-container"}>
                    <span>{props.error}</span>
                </div>
            );
        }
        const onCategoryChange = (evt) => {
            props.onCategoryChange(getProductCategory(evt.target.value));
        };
        return (
            <div className={"settings-content"}>
                <p className="settings-content__title">{props.configuration.selectProductCategoryText}</p>
                <div className={"settings-content__data-row"}>
                    <select
                        onChange={onCategoryChange}
                        value={props.selectedProductCategory != null ? props.selectedProductCategory.guid : ""}
                    >
                        <option value={""}/>
                        {options}
                    </select>

                </div>
                {temperaturesContent}
                {error}
            </div>
        );
    };
